/* eslint-disable prettier/prettier */
/* prettier-ignore */
/*
 * AUTO GENERATED FILE, PLEASE DONT EDIT MANUALLY
 */
//
export type Translation = 'discountCode'|'in'|'lastSearches'|'backToTop'|'allCategories'|'cmsModuleSearchInputPlaceholder'|'cmsModuleSearchText'|'accept'|'moreInfo'|'CookieLayerText'|'clearAll'|'filters'|'cancel'|'close'|'continue'|'highestRate'|'lowestRate'|'questionForComment'|'questionForScore'|'submit'|'thanksForParticipation'|'feedbackFormPlaceholder'|'zipCodeErrorMessage'|'zipCodeInputHeader'|'zipCodeInputHeaderMerchants'|'ok'|'zipCodeInputPlaceholder'|'searchHide'|'zipCodeSearchShow'|'zipCodeResolveError'|'components.FilterLocalInfo.zipCodeResolveText'|'refineButton'|'filterSearchInputPlaceholder'|'showLess'|'showMore'|'filterLocalInfo'|'filterLocalInfoChecked'|'zipCode'|'copyrightText'|'emailInvalid'|'newsletterHeadline'|'emailAdress'|'privacy'|'privacyInfo'|'newsletterSubheadline'|'subscribe'|'footerTitle'|'currentLocation'|'categoryTitle'|'og.description.category'|'document.title.searchPage'|'og.title.searchPage'|'document.title.wishlistPage'|'localDealers'|'search'|'aboutBranch'|'companyNameTemplate'|'localDealer.imageAltText'|'meta.description.localDealerPage'|'openingHours'|'streetAndHouseNumber'|'list'|'map'|'topCategories'|'navigateBack'|'meta.description.localSearchPage'|'openingInfo'|'openNow'|'document.title.localDealersPage'|'partnerMoreInfo'|'lessFilters'|'moreFilters'|'filterPanelTitle'|'categories'|'topProducts'|'loadMore'|'noProductsInfo'|'locallyAvailable'|'favoriteFlag'|'new'|'code'|'recommended'|'topseller'|'freeShipping'|'localProduct'|'shippingPrice'|'notAvailable'|'toShop'|'popularity'|'priceAsc'|'priceDesc'|'sortBy'|'ourRecommendations'|'freeShiping'|'deliveryInfo'|'deliveryTime'|'taxIncluded'|'toShop2'|'shop'|'otherCategories'|'applyFilters'|'ourTopCategories'|'today'|'browse'|'wishListEmptyText'|'myWishlist'|'notWishlisted'|'wishlisted'|'localSearchTitle'|'merchantAdMainTitle'|'partnerRedirect'|'partnerWebsite'|'menu'|'dealer'|'back'|'searchInputPlaceholder'|'searchInputPlaceholderSM'|'searchInputPlaceholderXS'|'wishlist'|'allInCategory'|'products'|'productsCountOutofTotal'|'filterLocalInfoPostcode'|'zipCodeResolveText'|'zipCodeInputOk'|'zipCodeInputError'|'showProductsForAustriaMsg'|'showProductsForSwissMsg'|'showAllProductsMsg'|'countrySpecificProductsHeadline'|'newsletterFooterHeadline'|'newsletterFooterDataProtectionNote'|'newsletterFooterDataProtectionLinkLabel'|'newsletterFooterSignUpButtonPlaceholder'|'newsletterFooterSignUpButtonLabel'|'newsletterFooterInvalidEmailErrorMessage'|'newsletterFooterGeneralErrorMessage'|'newsletterFooterEmailAlreadyRegisteredMessage'|'newsletterFooterSubmitSuccessMessage'|'newsletterFooterSubmitSuccessMessage2'|'newsletterFooterHeading'|'newsletterFooterContentfulTrends'|'newsletterFooterContentfulHighlights'|'newsletterFooterContentfulOffers'|'quickListHeaderTextFallback'|'helloUser'|'sendNewsletterOption'|'termsAndConditions'|'terms'|'conditions'|'save'|'signInAndSavePromoTextOne'|'signInAndSavePromoTextTwo'|'registerAndSaveWishlist'|'ifYouLoginText'|'benifitsOfLoginTextOne'|'benifitsOfLoginTextTwo'|'loginWithFacebook'|'productIsOffline'|'country'|'deliveryForAT'|'deliveryForCH'|'allProducts'|'localizationTitle'|'cookieUsageDescription'|'greetingsFromMoebel'|'trackingOptions'|'cookieBannerDataProtectionURL'|'cookieBannerImpressum'|'cookieBannerAltText'|'clearFiltersNotifierTexts'|'categoryTitleWithSeoFacet'|{ key: 'questionForComment';
values:{ score : string | number }}|{ key: 'filterSearchInputPlaceholder';
values:{ label : string | number }}|{ key: 'copyrightText';
values:{ year : string | number }}|{ key: 'privacyInfo';
values:{ privacy : string | number }}|{ key: 'categoryTitle';
values:{ categoryName : string | number }}|{ key: 'document.title.searchPage';
values:{ searchTerm : string | number }}|{ key: 'og.title.searchPage';
values:{ searchTerm : string | number }}|{ key: 'companyNameTemplate';
values:{ COMPANY_NAME : string | number, CITY_NAME : string | number }}|{ key: 'meta.description.localDealerPage';
values:{ COMPANY_TEMPLATE : string | number }}|{ key: 'streetAndHouseNumber';
values:{ street : string | number, houseNumber : string | number }}|{ key: 'openingInfo';
values:{ dayOfWeek : string | number, timeHours : string | number }}|{ key: 'shippingPrice';
values:{ price : string | number }}|{ key: 'allInCategory';
values:{ title : string | number }}|{ key: 'products';
values:{ productCount : string | number }}|{ key: 'productsCountOutofTotal';
values:{ productCount : string | number, totalCount : string | number }}|{ key: 'helloUser';
values:{ USER_NAME : string | number }}|{ key: 'termsAndConditions';
values:{ terms : string | number, conditions : string | number }}|{ key: 'categoryTitleWithSeoFacet';
values:{ category : string | number, facetValueName : string | number }};
export const translations: { [key: string]: { [key: string]: string } } = {
  discountCode: { de: 'Aktionscode', fr: 'Code Promo', nl: 'Promotie code' },
  in: { de: 'bei', fr: 'chez', nl: 'op' },
  lastSearches: { de: 'Letzte Suchen', fr: 'Dernières recherches', nl: 'Laatste zoekopdrachten' },
  backToTop: { de: 'Nach oben', fr: 'Remonter', nl: 'Naar boven' },
  allCategories: { de: 'Alle Kategorien', fr: 'Toutes les catégories', nl: 'Alle categorieën' },
  cmsModuleSearchInputPlaceholder: {
    de: 'Suche in 3 Mio. Produkten',
    fr: 'Que recherchez-vous?',
    nl: 'Zoek in onze enorme selectie van producten',
  },
  cmsModuleSearchText: {
    de: 'Finde jetzt dein neues Lieblings-Möbelstück aus über 250 Möbel- und Einrichtungsshops',
    fr: "Trouve ton nouveau meuble préféré parmi plus de 150 boutiques d'aménagement",
    nl: 'Vind nu jouw nieuwe favoriete meubelstuk in onze meubel- en inrichtingsshops',
  },
  accept: { de: 'akzeptieren', fr: 'Accepter', nl: '' },
  moreInfo: { de: 'Mehr erfahren', fr: 'En savoir plus', nl: '' },
  CookieLayerText: {
    de: 'Cookies helfen uns bei der Bereitstellung unserer Dienste. Durch die Nutzung unserer Dienste stimmen Sie der Verwendung von Cookies zu.',
    fr: "Les cookies nous aident à mesurer la qualité de nos services. En poursuivant votre navigation, vous acceptez l'utilisation des cookies.",
    nl: '',
  },
  clearAll: { de: 'alle löschen', fr: 'supprimer les filtres', nl: 'alles verwijderen' },
  filters: { de: 'filtern', fr: 'filtrer', nl: 'filtreren' },
  cancel: { de: 'abbrechen', fr: 'annuler', nl: 'annuleren' },
  close: { de: 'schließen', fr: 'fermer', nl: 'sluiten' },
  continue: { de: 'weiter', fr: 'continuer', nl: 'doorgaan ' },
  highestRate: { de: 'sehr wahrscheinlich', fr: ' très probable', nl: '' },
  lowestRate: { de: 'sehr unwahrscheinlich', fr: ' très peu probable', nl: '' },
  questionForComment: {
    de: 'Erzähl uns bitte, warum du eine "{score}" gewählt hast und wie wir uns weiter verbessern können.',
    fr: 'Pouvez-vous nous expliquer votre choix et comment nous pourrions améliorer notre service ?',
    nl: '',
  },
  questionForScore: {
    de: 'Wie wahrscheinlich ist es, dass du moebel.de Freunden oder Bekannten empfiehlst?',
    fr: 'Êtes-vous susceptible de recommander meubles.fr à un ami ou à un collègue?',
    nl: '',
  },
  submit: { de: 'abschicken', fr: 'envoyer', nl: '' },
  thanksForParticipation: { de: 'Vielen Dank für deine Meinung.', fr: 'Merci pour votre participation.', nl: '' },
  feedbackFormPlaceholder: { de: 'Bitte trag dein Feedback ein.', fr: 'Partagez-nous vos suggestions.', nl: '' },
  zipCodeErrorMessage: {
    de: 'Diese PLZ ist nicht gültig',
    fr: "Ce code postal n'existe pas.",
    nl: 'Deze postcode is niet geldig',
  },
  zipCodeInputHeader: {
    de: 'Finde Produkte in deiner Nähe',
    fr: 'Trouver des produits à proximité',
    nl: 'Vind producten in jouw buurt',
  },
  zipCodeInputHeaderMerchants: {
    de: 'Finde Händler in deiner Nähe',
    fr: 'Trouvez un revendeur à proximité.',
    nl: 'Vind dealers in jouw buurt',
  },
  ok: { de: 'Ok', fr: 'Ok', nl: 'Ok' },
  zipCodeInputPlaceholder: { de: 'Bitte gib deine PLZ ein', fr: 'Votre code postal ici', nl: 'Vul jouw postcode in' },
  searchHide: { de: 'Suche verbergen', fr: 'Masquer la recherche', nl: 'Verberg zoekopdracht' },
  zipCodeSearchShow: { de: 'Händler-Suche anpassen', fr: 'Affiner la recherche', nl: 'Dealer-zoekopdracht aanpassen' },
  zipCodeResolveError: {
    de: 'Wir konnten deinen Standort nicht automatisch feststellen. Bitte gib eine PLZ in Deiner Nähe ein.',
    fr: 'Nous ne pouvons pas vous localiser automatiquement. Merci de renseigner votre code postal dans le champs ci-dessous.',
    nl: 'We konden jouw locatie niet automatisch bepalen. Voer een postcode in bij je in de buurt.',
  },
  'components.FilterLocalInfo.zipCodeResolveText': {
    de: 'Aktuellen Ort verwenden',
    fr: 'Localisez-moi',
    nl: 'Huidige locatie gebruiken',
  },
  refineButton: { de: 'Ergebnis verfeinern', fr: 'Affiner la recherche', nl: 'Resultaat verfijnen' },
  filterSearchInputPlaceholder: { de: '{label} durchsuchen', fr: 'chercher', nl: '{label} doorzoeken' },
  showLess: { de: 'weniger anzeigen', fr: 'réduire', nl: 'minder tonen' },
  showMore: { de: 'weitere anzeigen', fr: 'afficher plus', nl: 'meer tonen' },
  filterLocalInfo: { de: 'in der Nähe', fr: 'à proximité', nl: 'in de buurt' },
  filterLocalInfoChecked: { de: 'in der Nähe von', fr: 'à proximité de', nl: 'in de buurt van' },
  zipCode: { de: 'PLZ', fr: 'Code postal', nl: 'Postcode' },
  copyrightText: {
    de: '© Copyright {year} moebel.de Einrichten & Wohnen AG',
    fr: '© Copyright {year} meubles.fr est un service proposé par moebel.de Einrichten & Wohnen AG',
    nl: '© Copyright {year} moebel.de Einrichten & Wohnen AG',
  },
  emailInvalid: {
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    fr: 'Veuillez renseigner une adresse mail valide',
    nl: 'Vul een geldig e-mailadres in.',
  },
  newsletterHeadline: {
    de: 'Der moebel.de Newsletter',
    fr: 'La newsletter Meubles.fr',
    nl: 'De meubelo.nl newsletter',
  },
  emailAdress: { de: 'E-Mail-Adresse', fr: 'Adresse mail', nl: 'E-mail adres' },
  privacy: { de: 'Datenschutzhinweise', fr: 'termes et conditions générales', nl: 'Privacybeleid' },
  privacyInfo: {
    de: 'Die {privacy} habe ich zur Kenntnis genommen.',
    fr: 'J’ai pris connnaissance et j’accepte les {privacy}.',
    nl: 'Ik heb nota genomen van het {privacy}.',
  },
  newsletterSubheadline: {
    de: 'Sale-Aktionen, Trends, Tipps, Wohnideen.',
    fr: "Promotions, nouveautés, tendances en un clin d'oeil !",
    nl: 'Sale-acties, trends, tips, woonideeën.',
  },
  subscribe: { de: 'Abonnieren', fr: "S'ABONNER", nl: 'Abonnieren' },
  footerTitle: {
    de: 'moebel.de: Deutschlands größtes Möbel- und Einrichtungsportal mit über 3.000.000 Produkten',
    fr: 'meubles.fr: Le plus grand choix de meubles et de déco du web',
    nl: 'meubelo.nl: een van de grootste meubel- en inrichtingsportalen van Nederland',
  },
  currentLocation: { de: 'Standort', fr: 'Localisation', nl: 'Locatie' },
  categoryTitle: {
    de: 'Jetzt entdecken: {categoryName}',
    fr: "Découvrez les produits de l'univers {categoryName}",
    nl: 'Ontdek nu: {categoryNae}',
  },
  'og.description.category': {
    de: 'Deutschlands größtes Möbel- und Einrichtungsportal ★ Entdecke 3 Mio. Produkte aus 250 Shops ★ Spare bis zu 70%',
    fr: 'Large choix de meubles et produits déco. Disponibles en ligne ou en magasin. Cherchez parmi plus de 700 000 produits et profitez de nos promotions.',
    nl: 'Een van de grootste meubel- en inrichtingsportalen van Nederland ★ Ontdek jouw favoriete product in onze enorme selectie ★ Bespaar tot 70%',
  },
  'document.title.searchPage': {
    de: 'Suche nach {searchTerm} | moebel.de',
    fr: 'Recherche pour {searchTerm}',
    nl: 'Zoek naar {searchTerm} | meubelo.nl',
  },
  'og.title.searchPage': {
    de: 'Meine Suche: {searchTerm}',
    fr: 'Ma recherche: {searchTerm}',
    nl: 'Mijn zoekopdracht: {searchTerm}',
  },
  'document.title.wishlistPage': { de: 'Merkzettel', fr: "Mes listes d'envies", nl: 'Notitieblok' },
  localDealers: { de: 'Lokal', fr: 'Magasins', nl: 'Lokaal' },
  search: { de: 'Suche', fr: 'Rechercher', nl: 'Zoeken' },
  aboutBranch: { de: 'Über diese Filiale', fr: 'Ce magasin', nl: 'Over deze winkel' },
  companyNameTemplate: {
    de: '{COMPANY_NAME} in {CITY_NAME}',
    fr: '{COMPANY_NAME} à {CITY_NAME}',
    nl: '{COMPANY_NAME} in {CITY_NAME}',
  },
  'localDealer.imageAltText': { de: 'Händlerbild', fr: 'image des partenaires', nl: 'Afbeelding dealer' },
  'meta.description.localDealerPage': {
    de: 'Händler vor Ort bei moebel.de - {COMPANY_TEMPLATE}',
    fr: 'Revendeur local chez meubles.fr - {COMPANY_TEMPLATE}',
    nl: 'Lokale dealer op meubelo.nl - {COMPANY_TEMPLATE}',
  },
  openingHours: { de: 'Öffnungszeiten', fr: "Heures d'ouverture", nl: 'Openingstijden' },
  streetAndHouseNumber: { de: '{street} {houseNumber}', fr: '{houseNumber} {street}', nl: '{street} {houseNumber}' },
  list: { de: 'Liste', fr: 'Annuaire', nl: 'Lijst' },
  map: { de: 'Karte', fr: 'Carte', nl: 'Kaart' },
  topCategories: { de: 'Top-Kategorien', fr: 'Catégories populaires', nl: 'Top categorieën' },
  navigateBack: { de: 'Zurück zum Sortiment', fr: 'Retour aux produits', nl: 'Terug naar het assortiment' },
  'meta.description.localSearchPage': {
    de: 'Möbelhäuser finden | moebel.de',
    fr: 'Trouver des magasins de meubles | meubles.fr',
    nl: 'Vind meubelwinkels | meubelo.nl',
  },
  openingInfo: {
    de: 'öffnet wieder am {dayOfWeek}, {timeHours} Uhr',
    fr: 'ouvre à nouveau {dayOfWeek}, {timeHours} heure',
    nl: 'heropent {dayOfWeek}, {timeHours} uur',
  },
  openNow: { de: 'jetzt geöffnet', fr: 'ouvert accuellement', nl: 'nu geopend' },
  'document.title.localDealersPage': {
    de: 'Möbelhäuser finden | moebel.de',
    fr: 'Trouver des magasins de meubles | meubles.fr',
    nl: 'Vind meubelwinkels | meubelo.nl',
  },
  partnerMoreInfo: { de: 'mehr Infos', fr: 'Découvrir', nl: 'meer info' },
  lessFilters: { de: 'weniger Filter anzeigen', fr: 'afficher moins de filtres', nl: 'minder filters tonen' },
  moreFilters: { de: 'weitere Filter anzeigen', fr: 'afficher plus de filtres', nl: 'meer filters tonen' },
  filterPanelTitle: { de: 'Machs dir schoen.', fr: 'Un monde pour chez vous.', nl: 'Maak het mooi' },
  categories: { de: 'Kategorie', fr: 'Catégories', nl: 'Categorie' },
  topProducts: { de: 'Top-Produkte', fr: 'Produits les plus populaires', nl: 'Top producten' },
  loadMore: { de: 'mehr anzeigen', fr: 'plus de produits', nl: 'meer tonen' },
  noProductsInfo: {
    de: 'Zu deiner Suche gibt es aktuell keine passenden Produkte.\r\n\r\nBitte wähle Filter ab, nutze eine andere Kategorie oder gebe einen neuen Suchbegriff ein.',
    fr: "Nous n’avons trouvé aucun résultat pour votre recherche. \r\n\r\n Essayez avec d'autres filtres ou modifiez les mots clés.",
    nl: 'Er zijn momenteel geen overeenkomende producten voor jouw zoekopdracht. \r\n\r\nDeselecteer filters, gebruik een andere categorie of voer een nieuwe zoekterm in.',
  },
  locallyAvailable: { de: 'auch lokal verfügbar', fr: 'Disponible à proximité', nl: 'ook lokaal verkrijgbaar' },
  favoriteFlag: { de: 'Beliebter Artikel', fr: 'Article populaire', nl: 'Populair artikel' },
  new: { de: 'Neu', fr: 'New', nl: 'Nieuw' },
  code: { de: 'Code', fr: 'Code', nl: 'Code' },
  recommended: { de: 'Unser Tipp', fr: 'nos allusion', nl: 'Onze tip' },
  topseller: { de: 'Topseller', fr: 'Autres Produits', nl: 'Topseller' },
  freeShipping: { de: 'versandkostenfrei', fr: 'livraison gratuite', nl: 'gratis verzending' },
  localProduct: { de: 'lokal verfügbar', fr: 'Disponible à proximité', nl: 'lokaal verkrijgbaar' },
  shippingPrice: { de: 'zzgl. {price} Versand', fr: '+ frais de livraison: {price}', nl: 'plus {price} verzending' },
  notAvailable: {
    de: 'Derzeit nicht verfügbar',
    fr: "Le produit n'est plus disponible.",
    nl: 'Op dit moment niet beschikbaar',
  },
  toShop: { de: 'zum Shop', fr: 'Vers la boutique', nl: 'naar de shop' },
  popularity: { de: 'Beliebtheit', fr: 'Popularité', nl: 'Populariteit' },
  priceAsc: { de: 'Preis aufsteigend', fr: 'Prix croissants', nl: 'Prijs stijgend' },
  priceDesc: { de: 'Preis absteigend', fr: 'Prix décroissants', nl: 'Prijs dalend' },
  sortBy: { de: 'sortiert nach', fr: 'Trier par', nl: 'gesorteerd naar' },
  ourRecommendations: { de: 'Unsere Empfehlungen', fr: 'Nos recommandations', nl: 'Onze aanbevelingen' },
  freeShiping: { de: 'versandkostenfrei', fr: 'livraison gratuite', nl: 'gratis verzending' },
  deliveryInfo: { de: 'zzgl. Versand', fr: '+ frais de livraison', nl: 'plus verzending' },
  deliveryTime: { de: 'Lieferzeit', fr: 'Livraison', nl: 'Levertijd' },
  taxIncluded: { de: 'inkl. MwSt.', fr: 'TVA incluse', nl: 'incl. BTW' },
  toShop2: { de: 'Zum Shop', fr: 'Vers la boutique', nl: 'Naar de shop' },
  shop: { de: 'Shop', fr: 'Boutique', nl: 'Shop' },
  otherCategories: { de: 'Weitere Kategorien', fr: 'Autres catégories', nl: 'Andere categorieën' },
  applyFilters: { de: 'Ergebnisse anzeigen', fr: 'Afficher les résultats', nl: 'Toon resultaten' },
  ourTopCategories: { de: 'Unsere Top-Kategorien', fr: 'Nos meilleures catégories', nl: 'Onze top categorieën' },
  today: { de: 'heute', fr: 'Aujd :', nl: 'vandaag' },
  browse: { de: 'Jetzt stöbern', fr: 'Commencez votre shopping !', nl: 'Nu bladeren' },
  wishListEmptyText: {
    de: 'Sehen, verlieben, merken. Behalte Deine Traumstücke im Blick, indem du auf das Herz-Icon klickst.',
    fr: 'Cherchez, craquez, ajoutez à votre liste. En cliquant sur le coeur, vous pouvez sauvegarder des produits dans vos listes pour les retrouver plus facilement.',
    nl: 'Zie het, word er verliefd op, onthoud het. Hou je droomstukken in het oog door op het harticoon te klikken.',
  },
  myWishlist: { de: 'Meine Wunschliste', fr: "Mes listes d'envies", nl: 'Mijn verlanglijstje' },
  notWishlisted: { de: 'merken', fr: 'enregistrer', nl: 'onthouden' },
  wishlisted: { de: 'gemerkt', fr: 'enregistré', nl: 'is onthouden' },
  localSearchTitle: { de: 'Weitere Händler finden', fr: "Trouver d'autres magasins", nl: 'Meer dealers vinden' },
  merchantAdMainTitle: {
    de: 'Wohnexperte in deiner Nähe:',
    fr: 'Spécialiste à proximité :',
    nl: 'Woonexpert in jow buurt:',
  },
  partnerRedirect: { de: 'zur Händlerseite', fr: "Plus d'infos", nl: 'naar de dealerpagina' },
  partnerWebsite: { de: 'zur Website >', fr: 'Site >', nl: 'naar de website >' },
  menu: { de: 'Menü', fr: 'Menu', nl: 'Menu' },
  dealer: { de: 'Händler', fr: 'Magasins', nl: 'Dealer' },
  back: { de: 'zurück', fr: 'retour', nl: 'Terug ' },
  searchInputPlaceholder: {
    de: 'Suche nach Produkten, Marken und Shops',
    fr: 'Que recherchez-vous ?',
    nl: 'Zoeken naar producten, merken en shops',
  },
  searchInputPlaceholderSM: {
    de: 'Suche nach Produkten und mehr',
    fr: 'Que recherchez-vous ?',
    nl: 'Zoeken naar producten en meer',
  },
  searchInputPlaceholderXS: { de: 'Suchbegriff', fr: 'Que recherchez-vous ?', nl: 'Zoekterm' },
  wishlist: { de: 'Wunschliste', fr: 'Listes d’envies', nl: 'Verlanglijstje' },
  allInCategory: { de: 'Alle in {title}', fr: "Tout l'univers {title}", nl: 'Alles in {title}' },
  products: { de: '{productCount} Produkte', fr: '{productCount} produits', nl: '{productCount} producten' },
  productsCountOutofTotal: {
    de: '{productCount} von {totalCount} Produkten gesehen',
    fr: 'Vous avez vu {productCount} produits sur {totalCount}',
    nl: '{productCount} van {totalCount} producten gezien',
  },
  filterLocalInfoPostcode: { de: 'PLZ', fr: 'Code postal', nl: 'Postcode' },
  zipCodeResolveText: { de: 'Aktuellen Ort verwenden', fr: 'Localisez-moi', nl: 'Huidige locatie gebruiken' },
  zipCodeInputOk: { de: 'Ok', fr: 'Ok', nl: 'Ok' },
  zipCodeInputError: {
    de: 'Diese PLZ ist nicht gültig',
    fr: "Ce code postal n'existe pas.",
    nl: 'Deze postcode is niet geldig',
  },
  showProductsForAustriaMsg: {
    de: 'Nur Produkte mit Lieferoption nach Österreich',
    fr: 'Uniquement produits avec option de livraison en Autriche',
    nl: '',
  },
  showProductsForSwissMsg: {
    de: 'Nur Produkte mit Lieferoption in die Schweiz',
    fr: 'Uniquement produits avec option de livraison en Suisse',
    nl: '',
  },
  showAllProductsMsg: {
    de: 'Gesamtes Sortiment von moebel.de',
    fr: 'Assortiment complet de moebel.de',
    nl: 'Compleet assortiment van meubelo.nl',
  },
  countrySpecificProductsHeadline: {
    de: 'Dein länderspezifisches Sortiment',
    fr: 'Votre pays spécifique assortiment',
    nl: '',
  },
  newsletterFooterHeadline: {
    de: 'Erhalte tolle Angebote für dein Zuhause.',
    fr: 'Restez informé sur les offres et promotions.',
    nl: 'Krijg geweldige aanbiedingen voor jouw huis.',
  },
  newsletterFooterDataProtectionNote: {
    de: 'Mehr Infos zum',
    fr: 'En savoir plus sur notre ',
    nl: 'Meer info over de/het',
  },
  newsletterFooterDataProtectionLinkLabel: { de: 'Datenschutz', fr: 'politique de confidentialité.', nl: 'Privacy' },
  newsletterFooterSignUpButtonPlaceholder: {
    de: 'deine E-Mail-Adresse',
    fr: 'Votre adresse email',
    nl: 'je e-mailadres',
  },
  newsletterFooterSignUpButtonLabel: { de: 'jetzt anmelden', fr: 'Je m’inscris', nl: 'nu aanmelden' },
  newsletterFooterInvalidEmailErrorMessage: {
    de: 'Deine angegebene E-Mail ist leider nicht korrekt. Probier es nochmal.',
    fr: 'Adresse email non valide.',
    nl: 'Je aangegeven e-mail is onjuist. Probeer het nog eens',
  },
  newsletterFooterGeneralErrorMessage: {
    de: 'Leider ist etwas schiefgegangen. Probier es einfach noch einmal.',
    fr: 'Erreur générale.',
    nl: 'Helaas ging er iets mis. Probeer het nog eens.',
  },
  newsletterFooterEmailAlreadyRegisteredMessage: {
    de: 'Diese E-Mail Adresse ist schon bei uns registriert.',
    fr: 'L’adresse email existe.',
    nl: 'Dit e-mail adres is al bij ons geregistreerd.',
  },
  newsletterFooterSubmitSuccessMessage: {
    de: 'Fast geschafft! Bestätige deine Anmeldung bitte mit einem Klick auf den Aktivierungslink in deiner Bestätigungsmail',
    fr: 'Vous avez presque fini. Merci de vérifier votre adresse e-mail et de confirmer l’inscription.',
    nl: 'Bijna klaar! Bevestig jouw registratie door te klikken op de activeringslink in jouw bevestigingsmail.',
  },
  newsletterFooterSubmitSuccessMessage2: {
    de: 'Anmeldung erfolgreich',
    fr: 'Inscription validée',
    nl: 'Succesvolle aanmelding',
  },
  newsletterFooterHeading: { de: 'Unser Newsletter', fr: 'Notre newsletter', nl: 'Onzw newsletter' },
  newsletterFooterContentfulTrends: {
    de: 'Einrichtungs-Trends',
    fr: 'Inspiration et tendances',
    nl: 'Inrichting trends',
  },
  newsletterFooterContentfulHighlights: {
    de: 'Sortiments-Highlights',
    fr: 'Nouveautés produits',
    nl: 'Assortiments-highlights',
  },
  newsletterFooterContentfulOffers: { de: 'Sale-Aktionen', fr: 'Promotions', nl: 'Sale-acties' },
  quickListHeaderTextFallback: {
    de: 'Dein Produkt und was dazu passt:',
    fr: 'Votre produit et ce qui convient:',
    nl: 'Jouw product en wat erbij hoort:',
  },
  helloUser: { de: 'Hallo {USER_NAME}!', fr: 'Bonjour {USER_NAME}!', nl: 'Hallo {USER_NAME}!' },
  sendNewsletterOption: {
    de: 'Ich möchte über Neuigkeiten von moebel.de auf dem Laufenden gehalten werden',
    fr: 'Je souhaite être informé des nouveautés meubles.fr',
    nl: 'Ik wil graag op de hoogte gehouden worden van nieuws van meubelo.nl',
  },
  termsAndConditions: {
    de: 'Wenn du fortfährst, stimmst du den {terms} sowie der {conditions} von moebel.de Einrichten & Wohnen AG zu.',
    fr: 'En continuant, vous acceptez les {termes} et les {conditions} de meubles.fr.',
    nl: 'Door verder te gaan, ga je akkoord met de {terms} en {conditions} van moebel.de Einrichten & Wohnen AG.',
  },
  terms: { de: 'Nutzungsbedingungen', fr: 'Conditions d‘utilisation', nl: 'Gebruiksvoorwaarden' },
  conditions: { de: 'Datenschutzrichtlinie', fr: 'Politique de confidentialité', nl: 'Privacybeleid' },
  save: { de: 'speichern', fr: 'enregistrer', nl: 'opslaan' },
  signInAndSavePromoTextOne: {
    de: 'Melde dich an, um deine Lieblingsartikel dauerhaft zu speichern und deine gespeicherte Wunschliste anzusehen.',
    fr: 'Connectez-vous pour enregistrer vos articles préférés de façon permanente et afficher votre liste d’envies.',
    nl: 'Log in om jouw favoriete items permanent op te slaan en jouw opgeslagen verlanglijstje te bekijken.',
  },
  signInAndSavePromoTextTwo: {
    de: '<b>Besonders bequem:</b> Mit deiner Anmeldung kannst du deine Wunschliste auf all deinen Geräten betrachten.',
    fr: '<b>Petit plus:</b> avec votre inscription, vous pouvez afficher votre liste d’envies sur tous vos appareils.',
    nl: '<b>Extra handig:</b> Door je in te loggen kun je jouw verlanglijstje op al jouw toestellen bekijken.',
  },
  registerAndSaveWishlist: {
    de: 'anmelden & Wunschliste speichern',
    fr: 's’inscrire et enregistrer la liste d‘envies',
    nl: 'log in & bewaar verlanglijstje',
  },
  ifYouLoginText: {
    de: 'Logge dich ein und deine gemerkten Produkte sind:',
    fr: 'Connectez-vous et vos articles seront :',
    nl: 'Log in en jouw onthoudene producten zijn:',
  },
  benifitsOfLoginTextOne: {
    de: 'dauerhaft gespeichert',
    fr: 'enregistrés de façon permanente',
    nl: 'permanent opgeslagen',
  },
  benifitsOfLoginTextTwo: {
    de: 'auf all deinen Geräten verfügbar',
    fr: 'disponibles sur tous vos appareils',
    nl: 'beschikbaar op al jouw toestellen',
  },
  loginWithFacebook: { de: 'Weiter mit Facebook', fr: 'Continuer avec Facebook', nl: 'Doorgaan met Facebook' },
  productIsOffline: { de: 'Produkt nicht verfügbar', fr: 'Produit indisponible', nl: 'Product niet verkrijgbaar' },
  country: { de: 'Land', fr: '', nl: 'Land' },
  deliveryForAT: { de: 'Nur Produkte mit Lieferoption nach Österreich', fr: '', nl: '' },
  deliveryForCH: { de: 'Nur Produkte mit Liefer-option in die Schweiz', fr: '', nl: '' },
  allProducts: { de: 'Gesamtes Sortiment von moebel.de', fr: '', nl: 'Compleet assortiment van meubelo.nl' },
  localizationTitle: { de: 'Dein länderspezifisches Sortiment', fr: '', nl: '' },
  cookieUsageDescription: {
    de: 'Diese Seite nutzt Website Tracking-Technologien von Dritten, um ihre Dienste anzubieten, stetig zu verbessern und Werbung entsprechend der Interessen der Nutzer anzuzeigen. Ich bin damit einverstanden und kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern.',
    fr: 'Diese Seite nutzt Website Tracking-Technologien von Dritten, um ihre Dienste anzubieten, stetig zu verbessern und Werbung entsprechend der Interessen der Nutzer anzuzeigen. Ich bin damit einverstanden und kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen oder ändern.',
    nl: '',
  },
  greetingsFromMoebel: {
    de: 'moebel.de wünscht dir viel Spaß mit deinem bestmöglichen Stöber-Erlebnis.',
    fr: 'moebel.de wünscht dir viel Spaß mit deinem bestmöglichen Stöber-Erlebnis.',
    nl: 'meubelo.nl wenst je de best mogelijke surfervaring.',
  },
  trackingOptions: { de: 'Optionen', fr: 'Optionen', nl: 'Opties' },
  cookieBannerDataProtectionURL: { de: 'Datenschutzerklärung', fr: 'Datenschutzerklärung', nl: 'Privacybeleid' },
  cookieBannerImpressum: { de: 'Impressum', fr: 'Impressum', nl: 'Impressum' },
  cookieBannerAltText: { de: 'Schoen, dass du da bist!', fr: 'Schoen, dass du da bist!', nl: 'Mooi dat je er bent!' },
  clearFiltersNotifierTexts: {
    de: 'Oops, leider haben wir für deine Filterwahl nur wenig Produkte zu zeigen. Pro-Tipp: Wähle einen Filter ab um mehr Auswahl zu erhalten.',
    fr: 'Oups, malheureusement nous avons peu de produits pour le filtre que vous avez choisi. Notre conseil : sélectionnez un autre filtre pour avoir plus de choix.',
    nl: 'Oeps, helaas hebben we weinig producten om te laten zien voor jouw filter keuze. Pro-tip: Kies een filter om meer keuze te krijgen.',
  },
  categoryTitleWithSeoFacet: {
    de: '{category} in {facetValueName}',
    fr: '{category} en {facetValueName}',
    nl: '{category} in {facetValueName}m',
  },
};
